(() => {
  let currentVariantId = null;
  let allowUrlUpdates = false;
  let cleanupActive = false;

  function isProductUrl(url) {
    try {
      const u = new URL(url, window.location.origin);
      return u.pathname.includes("/products/");
    } catch {
      return false;
    }
  }

  function stripVariantParam() {
    const u = new URL(window.location.href);
    if (!u.searchParams.has("variant")) return;
    u.searchParams.delete("variant");
    window.history.replaceState({}, "", u.toString());
  }

  function updateUrlWithVariant(variantId) {
    if (!variantId) return;
    currentVariantId = String(variantId);

    const u = new URL(window.location.href);
    u.searchParams.set("variant", currentVariantId);
    window.history.replaceState({}, "", u.toString());
  }

  function getMainProductSection() {
    return (
      document.querySelector('main [data-section-type="main-product"]') ||
      document.querySelector('main [data-section-type*="product"]') ||
      document.querySelector("main") ||
      document
    );
  }

  // read variant id from dropdown the user changed
  function variantIdFromSelectTarget(target) {
    if (!target) return null;

    if (target.tagName === "SELECT") {
      const val = target.value;
      if (/^\d+$/.test(val)) return val;

      const opt = target.selectedOptions && target.selectedOptions[0];
      if (opt) {
        const dataId =
          opt.getAttribute("data-variant-id") ||
          opt.dataset?.variantId ||
          opt.value;
        if (dataId && /^\d+$/.test(dataId)) return dataId;
      }
    }
    return null;
  }

  // fallback: hidden id input in main form
  function variantIdFromMainForm() {
    const section = getMainProductSection();
    const form = section.querySelector('form[action*="/cart/add"]');
    if (!form) return null;

    const idEl =
      form.querySelector('input[name="id"]') ||
      form.querySelector('select[name="id"]');

    return idEl?.value || null;
  }

  function getVariantIdFromEvent(e) {
    const section = getMainProductSection();
    const t = e?.target;

    if (t && section.contains(t)) {
      const fromTarget = variantIdFromSelectTarget(t);
      if (fromTarget) return fromTarget;
    }
    return variantIdFromMainForm();
  }

  function forceVariantInUrl(baseUrl) {
    if (!isProductUrl(baseUrl)) return baseUrl;

    // during cleanup window or before user interaction, don't force
    if (cleanupActive || !allowUrlUpdates || !currentVariantId) return baseUrl;

    const u = new URL(baseUrl, window.location.origin);
    u.searchParams.set("variant", String(currentVariantId));
    return u.toString();
  }

  function patchHistoryMethod(methodName) {
    const original = history[methodName];
    history[methodName] = function (state, title, url) {
      if (typeof url === "string" && isProductUrl(url)) {
        url = forceVariantInUrl(url);
      }
      return original.call(this, state, title, url);
    };
  }

  function startCleanupWindow() {
    cleanupActive = true;

    const start = Date.now();
    const interval = setInterval(() => {
      if (allowUrlUpdates) {
        clearInterval(interval);
        cleanupActive = false;
        return;
      }
      stripVariantParam();
      if (Date.now() - start > 1500) {
        clearInterval(interval);
        cleanupActive = false;
      }
    }, 100);

    requestAnimationFrame(stripVariantParam);
    setTimeout(stripVariantParam, 0);
    setTimeout(stripVariantParam, 50);
    setTimeout(stripVariantParam, 150);
  }

  function init() {
    patchHistoryMethod("replaceState");
    patchHistoryMethod("pushState");

    const section = getMainProductSection();
    const urlOnLoad = new URL(window.location.href);
    const paramVariant = urlOnLoad.searchParams.get("variant");

    // What variant is actually selected on load?
    const initialSelected = variantIdFromMainForm();

    const paramIsNumeric = paramVariant && /^\d+$/.test(paramVariant);
    const initialIsNumeric = initialSelected && /^\d+$/.test(initialSelected);

    // RULE:
    // - If param is missing OR param equals the initially selected variant,
    //   strip it and keep URL clean until user interaction.
    // - If param exists AND differs from initial selection,
    //   treat as true deep link and keep it.
    if (
      !paramIsNumeric ||
      (paramIsNumeric && initialIsNumeric && paramVariant === initialSelected)
    ) {
      currentVariantId = null;
      allowUrlUpdates = false;
      startCleanupWindow(); // beats Dwell's init URL writes
    } else {
      // true deep link to non-default variant
      currentVariantId = paramVariant;
      allowUrlUpdates = true;
    }

    // real user interaction enables updates
    const enableUpdates = (e) => {
      if (!section.contains(e.target)) return;
      allowUrlUpdates = true;
    };
    document.addEventListener("pointerdown", enableUpdates, { passive: true });
    document.addEventListener("keydown", enableUpdates);
    document.addEventListener("click", enableUpdates);

    // once user has interacted, update on dropdown change
    document.addEventListener("change", (e) => {
      if (!allowUrlUpdates) return;
      const vid = getVariantIdFromEvent(e);
      if (vid) {
        requestAnimationFrame(() => updateUrlWithVariant(vid));
        setTimeout(() => updateUrlWithVariant(vid), 0);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();
